var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTurnArrow = function SvgTurnArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m4.19322 2.5c.47509 0 .86022.39438.86022.88088v4.54455c0 .88088.86021.88088.86021.88088h7.62995l-2.1799-1.98427c-.3551-.32321-.3871-.87999-.0715-1.2436.3157-.36361.8594-.39637 1.2145-.07316l3.8709 3.52353c.1837.16716.2887.40676.2887.65838 0 .25161-.105.49121-.2887.65841l-3.8709 3.5235c-.3551.3232-.8988.2904-1.2145-.0732-.3156-.3636-.2836-.9204.0715-1.2436l2.1799-1.9842s-7.62995 0-8.49016 0c-.86022 0-1.72043-.88091-1.72043-1.76179v-5.42543c0-.4865.38513-.88088.86021-.88088zm0 9.9765c.47509 0 .86022.3944.86022.8809v3.0765h-1.72043v-3.0765c0-.4865.38513-.8809.86021-.8809zm0 4.8383c-.47508 0-.86021-.3944-.86021-.8809h1.72043c0 .4865-.38513.8809-.86022.8809z",
    fill: "#777776",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTurnArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/turn_arrow.2483fe92.svg";
export { ForwardRef as ReactComponent };